module.exports = __webpack_public_path__ + "img/a_l2.dedc5b45.png";